export interface ProjectInfo {
  id: string; // 세부 페이지 명칭 및 프로젝트
  title: string; // 정식 프로젝트 제목
  abbreviated_title: string; // 약칭 프로젝트 제목
}
export const PROJECT_LIST: ProjectInfo[] = [];
export const PROJECT_NAV_LIST: Pick<ProjectInfo, 'id' | 'abbreviated_title'>[] =
  PROJECT_LIST.map((item) => ({
    id: item.id,
    abbreviated_title: item.abbreviated_title,
  }));

export const ITEM_LIST: {
  item_id: number;
  short_name: string;
  unit_per: number;
  count: number;
}[] = [
  {
    item_id: 1,
    short_name: '밥그릇',
    unit_per: 75,
    count: 1,
  },
  {
    item_id: 2,
    short_name: '국그릇',
    unit_per: 75,
    count: 2,
  },
  {
    item_id: 3,
    short_name: '반찬그릇(대)',
    unit_per: 100,
    count: 3,
  },
  {
    item_id: 4,
    short_name: '반찬그릇(중)',
    unit_per: 150,
    count: 4,
  },
  {
    item_id: 5,
    short_name: '반찬그릇(소)',
    unit_per: 117,
    count: 5,
  },
  {
    item_id: 6,
    short_name: '물/음료컵',
    unit_per: 150,
    count: 6,
  },
  {
    item_id: 7,
    short_name: '소주컵',
    unit_per: 117,
    count: 7,
  },
  {
    item_id: 8,
    short_name: '수저 세트',
    unit_per: 300,
    count: 8,
  },
];

export const LEGACY_ITEM_LIST: {
  item_id: number;
  short_name: string;
  unit_per: number;
  count: number;
}[] = [
  {
    item_id: 1,
    short_name: '밥/국',
    unit_per: 72,
    count: 1,
  },
  {
    item_id: 2,
    short_name: '접시(소)',
    unit_per: 150,
    count: 2,
  },
  {
    item_id: 3,
    short_name: '접시(중)',
    unit_per: 150,
    count: 3,
  },
  {
    item_id: 4,
    short_name: '접시(대)',
    unit_per: 100,
    count: 4,
  },
  {
    item_id: 5,
    short_name: '숫가락',
    unit_per: 300,
    count: 5,
  },
  {
    item_id: 6,
    short_name: '젓가락',
    unit_per: 300,
    count: 6,
  },
  {
    item_id: 7,
    short_name: '음료컵',
    unit_per: 150,
    count: 7,
  },
  {
    item_id: 8,
    short_name: '소주컵',
    unit_per: 300,
    count: 8,
  },
];

export const ORDER_STATE: {
  [key: number]: {
    'title': string;
    'color': string;
    'lable-class': string;
  };
} = {
  0: {
    'title': '미접수',
    'color': 'text-gray-700',
    'lable-class':
      'rounded-full border px-2 py-1 text-xs text-gray-700 font-bold border-gray-300 border-1',
  },
  200: {
    'title': '주문접수',
    'color': 'text-blue-200',
    'lable-class':
      'rounded-full border px-2 py-1 text-xs text-blue-200 font-bold border-blue-200 border-1',
  },
  202: {
    'title': '배송중',
    'color': 'text-blue-700',
    'lable-class':
      'rounded-full border px-2 py-1 text-xs text-blue-700 font-bold border-blue-700 border-1',
  },
  300: {
    'title': '배송완료',
    'color': 'text-grean-700',
    'lable-class':
      'rounded-full border px-2 py-1 text-xs text-green-700 font-bold border-green-700 border-1',
  },
  404: {
    'title': '주문취소',
    'color': 'text-red-500',
    'lable-class':
      'rounded-full border px-2 py-1 text-xs text-red-500 font-bold border-red-500 border-1',
  },
};
